"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToTop = void 0;
var pages_common_1 = require("@qwilr/pages-common");
function scrollToTop() {
    (0, pages_common_1.scrollTo)(".project-block .accept-wrapper");
}
exports.scrollToTop = scrollToTop;
